<template>
  <div>
    <section>
      <div v-if="headerActionLayout" class="rider-information__header">
        <strong class="rider-information__title">Rider Information</strong>
        <v-tooltip top>
          <v-btn
            medium
            dark
            round
            color="red"
            slot="activator"
            class="rider-information__resend-btn"
            :disabled="disableSelect"
            :loading="resending_order"
            @click="resendOrder()"
          >
            <v-icon left color="white">notification_important</v-icon>
            <span>Resend order</span>
          </v-btn>
          <span>Resend order</span>
        </v-tooltip>
      </div>
      <strong v-else style="font-size: 18px">Rider Information</strong>
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 class="pt-4 text-xs-left">
            <span> Current rider :</span>
            {{
              order_detail.order_rider_full_name != null
                ? order_detail.order_rider_full_name
                : "No rider"
            }}
            {{ order_detail.order_rider_tel }}
          </v-flex>

          <v-flex xs12 sm6 style="display: flex; align-items: center">
            <v-form ref="riderSelect" v-model="valid">
              <v-select
                clearable
                hide-details
                dense
                :disabled="disableSelect"
                :loading="changing_rider"
                v-model="form_rider.order_rider_id"
                :items="change_rider"
                item-text="rider_full_name_temp"
                item-value="rider_id"
                label="Change Rider"
                :rules="[(v) => !!v || 'โปรดเลือกไรเดอร์']"
              ></v-select>
            </v-form>
            <v-btn
              v-if="showConfirmBtn"
              :disabled="
                changing_rider ||
                $route.name == 'OrderDetailFood' ||
                $route.name == 'OrderDetailMessenger'
              "
              :loading="changing_rider"
              color="primary"
              class="black--text elevation-0"
              @click="updateRider()"
              ><span> Confirm</span>
            </v-btn>
          </v-flex>

          <div
            v-if="!headerActionLayout"
            style="position: absolute; right: 10px; top: 10px"
          >
            <v-tooltip top>
              <v-btn
                medium
                dark
                color="red"
                slot="activator"
                :disabled="disableSelect"
                :loading="resending_order"
                @click="resendOrder()"
              >
                <v-icon left color="white">notification_important</v-icon>
                <span>Resend order</span>
              </v-btn>
              <span>Resend order</span>
            </v-tooltip>
          </div>
        </v-layout>
      </v-container>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["order_detail", "isDisableRider", "headerActionLayout"],
  data() {
    return {
      valid: false,
      log_btn: false,
      resending_order: false,
      form_rider: {},
      changing_rider: false,
    };
  },
  computed: {
    ...mapState({
      order_status_id: (state) => state.fetchOrderListBack.order_status_id,
    }),
    ...mapGetters({
      change_rider: "fetchOrderDetailBack/getDataRiderWallet",
      isEditOrder: "isEditOrder",
    }),
    isFinalStatus() {
      return this.order_status_id == 6 || this.order_status_id == 7;
    },
    canOverride() {
      return (
        this.$store.state.permission.order.edit_view == 3 ||
        this.$store.state.Info.user_id == 6
      );
    },
    disableSelect() {
      return (
        this.isDisableRider ||
        this.changing_rider ||
        this.resending_order ||
        (this.isFinalStatus && !this.canOverride) ||
        this.isEditOrder ||
        this.$route.name == "OrderDetailFood" ||
        this.$route.name == "OrderDetailMessenger"
      );
    },
    showConfirmBtn() {
      return (
        (this.change_rider.length != 0 &&
          !this.isDisableRider &&
          !this.changing_rider &&
          !this.resending_order &&
          !this.isFinalStatus &&
          !this.isEditOrder) ||
        this.canOverride
      );
    },
  },
  watch: {},
  methods: {
    async resendOrder() {
      this.resending_order = true;
      if (
        this.order_detail.order_type == 1 ||
        this.order_detail.order_type == 3
      ) {
        let check = await this.$store.dispatch(
          "fetchOrderDetailBack/resendOrder",
          {
            order_id: this.order_detail.order_id,
            order_status_id: this.order_detail.order_status,
          }
        );
        if (check == true) {
          this.$emit("cloneOrder");
        }
      } else {
        let check = await this.$store.dispatch(
          "fetchOrderDetailBack/resendOrderME",
          {
            order_id: this.order_detail.order_id,
          }
        );
        if (check == true) {
          this.$emit("cloneOrder");
        }
      }
      this.resending_order = false;
    },
    async initRider() {
      this.changing_rider = true;
      try {
        await this.$store.dispatch("fetchOrderDetailBack/getDataRider");
      } finally {
        this.changing_rider = false;
      }
    },
    async updateRider() {
      if (this.changing_rider) return;

      if (this.$refs.riderSelect.validate()) {
        this.form_rider.order_code = this.order_detail.order_code;
        for (let value of this.change_rider) {
          if (value.rider_id == this.form_rider.order_rider_id) {
            this.form_rider.order_rider_full_name = value.rider_full_name;
            this.form_rider.order_rider_phone = value.rider_phone;
          }
        }
        let form = {
          order_id: this.order_detail.order_id,
          form_rider: this.form_rider,
        };
        this.changing_rider = true;
        try {
          let check = await this.$store.dispatch(
            "fetchOrderDetailBack/updateRider",
            form
          );
          if (check == true) {
            this.order_detail.order_rider_id = this.form_rider.order_rider_id;
            this.order_detail.order_rider_full_name =
              this.form_rider.order_rider_full_name;
            this.form_rider = {};
            this.$emit("cloneOrder");
          }
        } finally {
          this.changing_rider = false;
          this.$refs.riderSelect.resetValidation();
        }
      }
    },
  },
  created() {
    this.initRider();
  },
};
</script>

<style scoped>
.rider-information__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.rider-information__title {
  font-size: 18px;
  text-align: left;
}

.rider-information__resend-btn {
  margin: 0;
}

@media (max-width: 600px) {
  .rider-information__header {
    gap: 12px;
  }

  .rider-information__resend-btn {
    min-width: auto;
  }
}
</style>
